var _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21495 8.30968C5.13845 3.28172 7.80635 4.10261 9.65335 5.23134C11.5004 6.36006 15.297 10.1567 13.5526 11.388C11.7056 12.5167 9.96119 13.3376 9.96119 14.7742C9.96119 16.929 15.0918 21.957 17.2466 21.957C18.6832 21.957 19.4014 20.2126 20.6328 18.4682C21.7615 16.6212 25.5581 20.4178 26.6868 22.2648C27.8156 24.1118 28.7391 26.7797 23.7111 27.8058C13.963 29.6528 2.26533 17.9551 4.21495 8.30968ZM21.5563 4.61567V13.7481C21.5563 14.6716 20.2223 14.6716 20.2223 13.7481V4.61567C20.2223 3.79478 21.5563 3.79478 21.5563 4.61567ZM19.0936 6.77051V11.5932C19.0936 12.5167 17.7597 12.5167 17.7597 11.5932V6.77051C17.7597 5.847 19.0936 5.847 19.0936 6.77051ZM23.9163 6.77051V11.5932C23.9163 12.5167 22.5824 12.5167 22.5824 11.5932V6.77051C22.5824 5.847 23.9163 5.847 23.9163 6.77051Z",
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "phone_svg__mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21495 8.30968C5.13845 3.28172 7.80635 4.10261 9.65335 5.23134C11.5004 6.36006 15.297 10.1567 13.5526 11.388C11.7056 12.5167 9.96119 13.3376 9.96119 14.7742C9.96119 16.929 15.0918 21.957 17.2466 21.957C18.6832 21.957 19.4014 20.2126 20.6328 18.4682C21.7615 16.6212 25.5581 20.4178 26.6868 22.2648C27.8156 24.1118 28.7391 26.7797 23.7111 27.8058C13.963 29.6528 2.26533 17.9551 4.21495 8.30968ZM21.5563 4.61567V13.7481C21.5563 14.6716 20.2223 14.6716 20.2223 13.7481V4.61567C20.2223 3.79478 21.5563 3.79478 21.5563 4.61567ZM19.0936 6.77051V11.5932C19.0936 12.5167 17.7597 12.5167 17.7597 11.5932V6.77051C17.7597 5.847 19.0936 5.847 19.0936 6.77051ZM23.9163 6.77051V11.5932C23.9163 12.5167 22.5824 12.5167 22.5824 11.5932V6.77051C22.5824 5.847 23.9163 5.847 23.9163 6.77051Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#phone_svg__mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 4,
    width: 8,
    height: 11,
    fill: "#DC4E41"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1a769f25ffdeca506c34de36de232376.svg";
export { ForwardRef as ReactComponent };